import { ComponentPropsWithoutRef } from 'react';
import { lima } from '../colors';

export default function CheckCircleIcon(
  props: ComponentPropsWithoutRef<'svg'> & { color?: string },
) {
  const { color = lima } = props;
  return (
    <svg
      width="16px"
      height="17px"
      viewBox="0 0 16 17"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-479, -469)" stroke={color} strokeWidth="1.2">
          <g transform="translate(447.5, 100)">
            <g transform="translate(16.5, 224.5)">
              <g transform="translate(16.3359, 16)">
                <g transform="translate(0, 33)">
                  <g transform="translate(0, 97)">
                    <circle cx="7" cy="7" r="7" />
                    <polyline points="3.90604226 7.38183284 6.49677347 9.37666239 10.2826321 4.86256581" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
